import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types";
import { colors, resolveColor } from "utils/styles";
import renderItem from "utils/renderItem";
import getKey from "utils/getKey";
import Title from "./Title";
// import Media from "./Media";

import ImageCard from "./ImageCard";

import ButtonGroup from "./ButtonGroup";

import DynamicLink from "./DynamicLink";

import ArticleInclude from "./ArticleInclude";
import ConditionalWrapper from "components/Reusables/ConditionalWrapper";

export default function Content(props) {
	const fields = props.content?.fields;
	const classes = fields?.class;
	const contentLink = fields?.contentLink;
	const linkColor = resolveColor(fields?.linkColor || "green");
	// fields?.linkColor &&
	//  ? resolveColor(fields?.linkColor) : colors.green;

	const textColor = resolveColor(fields?.color || "lightBrown");
	const contentBackgroundColor = fields?.contentBackgroundColor;
	const lineHeight = fields?.lineHeight;
	const letterSpacing = fields?.letterSpacing;
	const columnWidth = fields?.columnWidth !== undefined ? fields?.columnWidth : 12;
	const contentClasses = fields?.contentClasses ? fields?.contentClasses : " ";

	const colorLine = fields?.colorLine ? resolveColor(fields?.colorLine) : null;

	const lineSide = fields?.colorLineSide;
	const thickness = fields?.colorLineThickness;
	const colorLinePadding = fields?.colorLinePadding;
	const align = fields?.textAlign;
	const fontSize = fields?.fontSize ? fields?.fontSize : 17;
	const maxWidth = fields?.maxWidth ? `${fields.maxWidth}px` : "100%";
	const hashLink = fields?.hashLink;

	return (
		<ConditionalWrapper
			condition={!!contentLink}
			wrapper={(children) => (
				<DynamicLink classes="" href={fields?.contentLink}>
					{children}
				</DynamicLink>
			)}
		>
			<div id={hashLink} className={`${contentClasses} g-0 ContentComponent row `}>
				<div
					style={{
						//conditionally add border for style
						...(colorLine && {
							[`border${lineSide}`]: `${thickness}px solid ${colorLine}`,
							...(colorLinePadding && {
								[`padding${lineSide}`]: `${colorLinePadding}em`,
							}),
						}),
						textAlign: align,
					}}
					className={`  col-${columnWidth} maxWidth`}
				>
					{fields?.text &&
						documentToReactComponents(fields.text, {
							renderText: (text) =>
								text
									.split("\n")
									.flatMap((text, i) => [
										i > 0 && <br key={getKey()} />,
										text ? (
											<React.Fragment key={getKey()}>{text}</React.Fragment>
										) : (
											<React.Fragment key={getKey()}></React.Fragment>
										),
									]),

							renderNode: {
								[BLOCKS.HEADING_1]: (node, children) => {
									return (
										<Title textAlign={align} element="h1" text={children} />
										// <h3 className={`${classes ? classes : " "}`} key={getKey()}>
										// 	{children}
										// </h3>
									);
								},
								[BLOCKS.HEADING_2]: (node, children) => {
									return (
										<Title textAlign={align} element="h2" text={children} />

										// <h3 className={`${classes ? classes : " "}`} key={getKey()}>
										// 	{children}
										// </h3>
									);
								},
								[BLOCKS.HEADING_3]: (node, children) => {
									return (
										<h3
											style={{ textAlign: align }}
											className={`${classes ? classes : " "}`}
											key={getKey()}
										>
											{children}
										</h3>
									);
								},
								[BLOCKS.HEADING_4]: (node, children) => {
									return (
										<h4
											style={{ textAlign: align }}
											className={`${classes ? classes : " "}`}
											key={getKey()}
										>
											{children}
										</h4>
									);
								},
								[BLOCKS.HEADING_5]: (node, children) => {
									return (
										<h5
											style={{ textAlign: align }}
											className={`${classes ? classes : " "}`}
											key={getKey()}
										>
											{children}
										</h5>
									);
								},
								[BLOCKS.HEADING_6]: (node, children) => {
									return (
										<h6
											style={{ textAlign: align }}
											className={`${classes ? classes : " "}`}
											key={getKey()}
										>
											{children}
										</h6>
									);
								},
								[BLOCKS.PARAGRAPH]: (node, children) => {
									return (
										<div className={`paragraph ${classes ? classes : " "}`} key={getKey()}>
											{children}
										</div>
										// <p className={`${classes ? classes : " "}`} key={getKey()}>
										// 	{children}
										// </p>
									);
								},

								[BLOCKS.UL_LIST]: (node, children) => {
									//bullet icons were aligned at the bottom of multi-row text, this fixed it
									return <ul className="content-list">{children}</ul>;
								},
								[BLOCKS.OL_LIST]: (node, children) => {
									//bullet icons were aligned at the bottom of multi-row text, this fixed it
									return <ol className="content-list">{children}</ol>;
								},

								[BLOCKS.QUOTE]: (node, children) => {
									return (
										<blockquote className="blockquote" key={getKey()}>
											{children}
										</blockquote>
									);
								},

								[BLOCKS.EMBEDDED_ASSET]: (node, children) => {
									return (
										<img
											key={getKey()}
											// className={`${node?.data?.target?.fields ? node?.data?.target?.fields : " "} w-100`}
											// className={`w-100`}
											src={node?.data?.target?.fields?.file?.url}
											alt={node?.data?.target?.fields?.description}
										/>
									);
								},

								[BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
									if (!node?.data?.target) {
										//some kind of contentful richtext editor bug giving empty embedded element blocks
										return <></>;
									}
									const type = node.data.target.sys.contentType.sys.id;
									if (type === "media") {
										return <ImageCard key={getKey()} data={node?.data?.target} />;
									} else if (type === "title") {
										return <Title key={getKey()} title={node?.data?.target} />;
									} else if (type === "content") {
										return <Content key={getKey()} content={node?.data?.target} />;
									} else if (type === "buttonGroup") {
										return <ButtonGroup key={getKey()} buttonGroupData={node?.data?.target} />;
									} else if (type === "articleInclude" || type === "table" || type === "cta") {
										return <ArticleInclude key={getKey()} data={node?.data?.target} />;
									}
								},

								[INLINES.HYPERLINK]: (node, children) => {
									return (
										<DynamicLink
											textDecoration={"underline"}
											key={getKey()}
											href={node.data.uri}
											text={children}
											color={linkColor}
										/>
									);
								},

								[INLINES.EMBEDDED_ENTRY]: (node, children) => {
									if (!node?.data?.target) {
										//some kind of contentful richtext editor bug giving empty embedded element blocks
										return <></>;
									}
									const type = node.data.target.sys.contentType.sys.id;

									if (type === "media") {
										return <ImageCard inline={true} key={getKey()} data={node?.data?.target} />;
									} else if (type === "title") {
										return <Title key={getKey()} title={node?.data?.target} />;
									} else if (type === "content") {
										const nestedContentClass = node.data.target.fields?.nestedContentClass || "";

										//make this inline if not already
										if (node?.data?.target) {
											if (node?.data?.target?.fields?.contentClasses) {
												if (
													!node?.data?.target.fields.contentClasses.includes("d-inline-block")
												) {
													node.data.target.fields.contentClasses = `${node?.data?.target?.fields?.contentClasses} d-inline-block `;
												}
											} else {
												node.data.target.fields.contentClasses = "d-inline-block";
											}
										}

										return (
											<span key={getKey()} className={nestedContentClass}>
												<Content content={node?.data?.target} />
											</span>
										);
									} else {
										return <span key={getKey()}>{renderItem(node.data.target)}</span>;
									}
								},

								[BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
									if (!node?.data?.target) {
										//some kind of contentful richtext editor bug giving empty embedded element blocks
										return <></>;
									}
									const type = node.data.target.sys.contentType.sys.id;

									if (type === "media") {
										return <ImageCard inline={false} key={getKey()} data={node?.data?.target} />;
									} else if (type === "title") {
										return <Title key={getKey()} title={node?.data?.target} />;
									} else if (type === "content") {
										const nestedContentClass = node.data.target.fields?.nestedContentClass || "";

										return (
											<span key={getKey()} className={nestedContentClass}>
												<Content content={node?.data?.target} />
											</span>
										);
									} else {
										return <span key={getKey()}>{renderItem(node.data.target)}</span>;
									}
								},
							},
							renderMark: {
								[MARKS.BOLD]: (text) => {
									return (
										<b className="boldColor" key={getKey()}>
											{text}
										</b>
									);
								},
							},
						})}
				</div>
			</div>
			<style jsx>{`
				.ContentComponent {
					background: ${resolveColor(contentBackgroundColor)};
				}
				.maxWidth {
					max-width: ${maxWidth};
				}

				.paragraph {
					color: ${textColor};
					text-align: ${fields?.textAlign || "start"};
					font-size: ${fontSize}px;
					line-height: ${lineHeight ? `${lineHeight}px` : "28px"};
					font-family: "Open Sans";
					margin: 0;
					letter-spacing: ${letterSpacing ? `${letterSpacing}px` : "0px"};
				}

				@media screen and (max-width: 991px) {
					.paragraph {
						font-size: ${fontSize ? `${fontSize}px` : "16px"};
						line-height: ${lineHeight ? `${lineHeight}px` : "26px"};
					}
				}

				.boldColor {
					/* font-weight: bold; */
					color: ${fields?.boldTextColor || fields?.color
						? resolveColor(fields?.boldTextColor || fields?.color)
						: "dark"};
				}

				h3 {
					font-weight: normal;
					font-size: 26px;
					line-height: ${lineHeight ? `${lineHeight}px` : "36px"};
					letter-spacing: ${letterSpacing ? `${letterSpacing}px` : "0px"};
				}
				h4 {
					font-family: "Open Sans";
					line-height: ${lineHeight ? `${lineHeight}px` : "28px"};
					color: ${resolveColor(fields?.color || colors.darkBlue)};
					margin-bottom: 20px;
				}
				h5 {
					font-family: "Open Sans";
					font-weight: 400;
					line-height: ${lineHeight ? `${lineHeight}px` : "25px"};
					color: ${resolveColor(fields?.color || "darkBlue")};
				}

				@media screen and (max-width: 992px) {
					h5 {
						font-size: 18px;
					}
				}
				@media screen and (min-width: 992px) {
					h5 {
						font-size: 20px;
					}
				}

				@media screen and (min-width: 1400px) {
					h5 {
						font-size: 22px;
					}
				}

				/* Content title, Normal font */
				h6 {
					font-size: 22px;
					line-height: ${lineHeight ? `${lineHeight}px` : "32px"};
					font-family: "Open Sans";
					color: ${resolveColor(fields?.color || "dark")};

					letter-spacing: ${letterSpacing ? `${letterSpacing}px` : "0px"};
				}

				blockquote {
					background: #f9f9f9; /* Light grey background */
					border-left: 10px solid #ccc; /* Grey left border */
					margin: 1.5em 10px; /* Some margin around the block quote */
					padding: 0.5em 10px; /* Padding inside the block quote */
					font-style: italic; /* Italic text style */
				}

				blockquote p {
					display: inline; /* Ensures inline display of paragraphs inside blockquote */
				}

				blockquote footer {
					text-align: right; /* Aligns the footer text to the right */
					font-size: 0.9em; /* Slightly smaller font size */
					color: #666; /* Medium grey text color */
					margin-top: 0.5em; /* Space above the footer text */
				}

				blockquote::before {
					content: open-quote; /* CSS way to insert left double quote */
					font-size: 4em; /* Large font size for the quote symbol */
					line-height: 0.1em; /* Adjusts the line height */
					margin-right: 0.25em; /* Space between quote symbol and text */
					vertical-align: -0.4em; /* Vertically align the quote symbol */
					color: #ccc; /* Light grey color for the quote symbol */
				}

				blockquote::after {
					content: close-quote; /* CSS way to insert right double quote */
					font-size: 4em; /* Large font size for the quote symbol */
					line-height: 0.1em; /* Adjusts the line height */
					margin-left: 0.25em; /* Space between quote symbol and text */
					vertical-align: -0.4em; /* Vertically align the quote symbol */
					color: #ccc; /* Light grey color for the quote symbol */
				}
			`}</style>
		</ConditionalWrapper>
	);
}
